'use client';

import { BaseCommand } from '@/types/BaseCommand';
import { Example } from '@/types/Example';
import { usePopulateStore } from '@/utils/hooks/usePopulateStore';
import useSignIn from '@/utils/hooks/useSignIn';
import { Flag } from '@/types/Flag';

interface InitialiseAppProps {
  examples: Example[];
  commands: BaseCommand[];
  flags: Flag[];
}

const InitialiseApp = (props: InitialiseAppProps) => {
  const { examples, commands, flags } = props;
  useSignIn();
  usePopulateStore(examples, commands, flags);
  return null;
};

export default InitialiseApp;
